import { BuyerApi } from 'api/BuyerApi';
import { LightTooltip } from 'components/shared/LightTooltip';
import { AppContext } from 'contexts/user/AppContext';
import { LoginResponseUserModel } from 'models/identity/LoginResponseUserModel';
import { ProjectInquiry } from 'pages/buyer/ProjectInquiry/ProjectInquiry';
import { useContext, useEffect, useState } from 'react';
import { useAuthUser } from 'react-auth-kit';
import { Badge, Nav, Offcanvas } from 'react-bootstrap';
import { ArrowsAngleExpand, ClipboardFill } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';

type PropTypes = {
  windowIsNarrow?: boolean;
};

export const ContinueProjectInquiryButton = ({ windowIsNarrow }: PropTypes) => {
  const [show, setShow] = useState<boolean>(false);

  const { t } = useTranslation('components');

  const navigator = useHistory();

  const { appState, appContextDispatch } = useContext(AppContext);

  const authUser = useAuthUser();
  const currentUser = authUser() as LoginResponseUserModel;

  const handleContinueOrder = () => {
    window.screen.availWidth < 800
      ? navigator.push(
          `/buyer/project/${appState.userProfile?.currentProject?.id}/project-inquiry/${appState.userProfile?.currentProject?.inquiryProjectId}`
        )
      : handleShow();
  };

  const handleShow = () => setShow(true);
  const handleHide = () => setShow(false);

  useEffect(() => {
    const getNumberOfRows = async () => {
      if (appState.userProfile?.currentProject.inquiryProjectId) {
        const response = await BuyerApi.projectInquiry.getProjectInquiryRows(
          currentUser.companyId,
          appState.userProfile?.currentProject.inquiryProjectId,
          appState.userProfile?.currentProject.id
        );

        appContextDispatch({
          type: 'BUYER_SET_CURRENT_INQUIRY_PROJECT_ROWS',
          currentInquiryProjectRows: response.length,
        });
      }
    };

    getNumberOfRows();
  }, [
    appContextDispatch,
    appState.userProfile?.currentProject.id,
    appState.userProfile?.currentProject.inquiryProjectId,
    currentUser.companyId,
  ]);

  return !windowIsNarrow ? (
    <>
      <Nav.Item
        data-tip
        data-for={`/buyer/project/${appState.userProfile?.currentProject?.id}/project-inquiry/${appState.userProfile?.currentProject?.inquiryProjectId}`}
        style={{ cursor: 'pointer' }}
        onClick={handleContinueOrder}
        className='ms-4 text-center position-relative float-end'
      >
        <Badge
          className='position-absolute'
          style={{ right: '-12px', top: '-5px' }}
          bg='success'
        >
          {appState.currentInquiryProjectRows}
        </Badge>

        <span className='buyer-nav-item d-flex flex-column align-items-center'>
          <ClipboardFill className='buyer-nav-item-icon-white' size={34} />
        </span>
      </Nav.Item>

      <LightTooltip
        place='bottom'
        id={`/buyer/project/${appState.userProfile?.currentProject?.id}/project-inquiry/${appState.userProfile?.currentProject?.inquiryProjectId}`}
      >
        <span className='buyer-nav-item-label'>
          {t('projectSettings.lbl_ContinueProjectInquiry')}
        </span>
      </LightTooltip>

      <Offcanvas
        // scroll
        // backdrop={false}
        style={{ maxWidth: '1200px' }}
        placement={'end'}
        show={show}
        onHide={handleHide}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <Link
              onClick={handleHide}
              className='btn-link-bold'
              to={`/buyer/project/${appState.userProfile?.currentProject?.id}/project-inquiry/${appState.userProfile?.currentProject?.inquiryProjectId}`}
            >
              {t('projectSettings.lbl_ContinueProjectInquiry')}{' '}
              <ArrowsAngleExpand className='icon-ez' />
            </Link>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <div
          style={{
            background: '#f7f9fc',
            overflowY: 'scroll',
          }}
        >
          <ProjectInquiry
            passedProjectInquiryId={
              appState.userProfile?.currentProject.inquiryProjectId ?? null
            }
            passedProjectId={appState.userProfile?.currentProject.id}
            handleHide={handleHide}
          />
        </div>
      </Offcanvas>
    </>
  ) : (
    <>
      <Nav.Item
        style={{ cursor: 'pointer' }}
        onClick={handleContinueOrder}
        className='ms-4 text-center'
      >
        <span className='buyer-nav-item buyer-nav-item-icon-container'>
          {t('projectSettings.lbl_ContinueProjectOrder')}
        </span>
      </Nav.Item>
    </>
  );
};
